import React, { Component, ReactElement } from 'react';

import { EventTokenListAPI } from '@philips-emr/tws-components-api';
import { Expression, Placement, Status } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { array, eventListener, number } from '@philips-emr/tws-core/lib/component/prop-types';
import { ClickEvent } from '@philips-emr/tws-core/lib/component/types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';

import { Link, Popover } from '..';

import { EventToken } from './components';
import './event-token-list.scss';

interface Event {
  status: Status;
  subtitle: string;
  title: string;
}

export interface EventTokenListProps {
  data: Event[];
  displayQuantity: number;
  onClick: (event: ClickEvent) => void;
  onContextMenuClick: (event: ClickEvent) => void;
  onDoubleClick: (event: ClickEvent) => void;
}

interface EventTokenListState {
  isPopoverOpen: boolean;
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: EventTokenListAPI })
class EventTokenList extends Component<EventTokenListProps, EventTokenListState> {
  state: EventTokenListState = {
    isPopoverOpen: false,
  };

  static propTypes = {
    data: array.notEnumerable(),
    displayQuantity: number,
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
  };

  static defaultProps = {
    data: [],
    displayQuantity: 3,
  };

  onSeeMore = (): void => {
    this.setState((prevState) => ({
      isPopoverOpen: !prevState.isPopoverOpen,
    }));
  };

  closePopover = (): void => {
    this.setState({ isPopoverOpen: false });
  };

  onEventTokenClick = (value: Event): void => {
    const { onClick } = this.props;

    onClick && onClick(new ClickEvent({ value }));
  };

  renderSeeMore = (hiddenEvents: Event[]): ReactElement | null => {
    const { isPopoverOpen } = this.state;

    if (!hiddenEvents.length) {
      return null;
    }

    const value = `${msg(Expression.SEE)} + ${hiddenEvents.length}`;

    return (
      <Popover open={isPopoverOpen} onClose={this.closePopover} placement={Placement.BOTTOM}>
        <Link onClick={this.onSeeMore} value={value} />

        <Popover.Content>
          {this.renderEventTokens(hiddenEvents, 'c-event-list__hidden-events')}
        </Popover.Content>
      </Popover>
    );
  };

  renderEventTokens = (events: Event[] = [], className = ''): ReactElement => {
    return (
      <div className={className}>
        {events.map((event, index) => (
          <EventToken
            {...event}
            key={index}
            onClick={() => this.onEventTokenClick(event)}
          />
        ))}
      </div>
    );
  };

  render(): ReactElement {
    const { data = [], displayQuantity } = this.props;

    const shownEvents = [...data];

    const hiddenEvents =
      shownEvents.length > displayQuantity
        ? shownEvents.splice(displayQuantity)
        : [];

    return (
      <div className="c-event-list">
        <div className="c-event-list__tokens">
          {this.renderEventTokens(shownEvents, 'c-event-list__tokens')}
        </div>
        <div className="c-event-list__see-more">
          {this.renderSeeMore(hiddenEvents)}
        </div>
      </div>
    );
  }
}

export default EventTokenList;
